import logger from '../utils/logger';

// Central fetch wrapper: injects Authorization and X-Tenant-Id headers from localStorage
export async function apiFetch(input: string, init: RequestInit = {}) {
    const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
    const url = input.startsWith('http') ? input : `${base}${input}`;

    // Skip auth for login endpoint
    const isLoginRequest = input.includes('/api/auth/login');

    // Normalize headers into a plain object
    const existingHeaders: Record<string, string> = {};
    if (init.headers instanceof Headers) {
        init.headers.forEach((v, k) => existingHeaders[k] = v);
    } else if (init.headers && typeof init.headers === 'object') {
        Object.assign(existingHeaders, init.headers as Record<string, string>);
    }

    // Get token and tenantId from localStorage
    const token = localStorage.getItem('token');
    const primaryTenantId = localStorage.getItem('tenantId');
    const fallbackTenantId = localStorage.getItem('selectedTenantId');
    const tenantId = primaryTenantId || fallbackTenantId || undefined;

    if (process.env.REACT_APP_DEBUG_AUTH === '1') {
        logger.debug('[apiFetch] token present?', Boolean(token));
        logger.debug('[apiFetch] tenantId present?', Boolean(tenantId));
    }

    // Add Authorization header if token exists and not login request
    if (token && !existingHeaders['Authorization'] && !isLoginRequest) {
        existingHeaders['Authorization'] = `Bearer ${token}`;
    }

    // Add X-Tenant-Id header if tenantId exists and not login request
    if (!existingHeaders['X-Tenant-Id'] && !isLoginRequest && tenantId) {
        existingHeaders['X-Tenant-Id'] = tenantId;
        logger.debug('[apiFetch] Injected X-Tenant-Id header');
    } else if (!isLoginRequest && !tenantId) {
        logger.debug('[apiFetch] No tenant ID found in storage');
    }

    // If body is FormData, don't set Content-Type (browser will set multipart boundary)
    const bodyIsForm = init.body instanceof FormData;
    const method = (init.method || 'GET').toUpperCase();
    if (method !== 'GET' && !bodyIsForm && !existingHeaders['Content-Type']) {
        // default to json for non-form requests
        existingHeaders['Content-Type'] = 'application/json';
    }

    const res = await fetch(url, { ...init, headers: existingHeaders, method });

    // Handle 401 Unauthorized - force logout and redirect to login page
    if (res.status === 401 && !isLoginRequest) {
        logger.warn('Authentication failed (401). Forcing logout.');

        // Clear auth data from localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('tenantId');
        localStorage.removeItem('username');
        localStorage.removeItem('fullName');

        // Redirect to login page
        window.location.href = '/login';
    }

    return res;
}
